import React, { useState, useEffect, useCallback } from 'react';
import { useScore } from '../../context/ScoreProvider';
import '../../styles/RangeQuizScreen.css';

export default function RangeQuizScreen({
  question,
  image,
  options,
  feedback,
  onCheckStateChange,
  screenId,
  screenScore
}) {
  const { submitAnswer } = useScore();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isChecked, setIsChecked] = useState(false);

  const selectedOption = options[selectedIndex];
  const isCorrect = !!selectedOption?.correct;

  const handleChange = (e) => {
    if (isChecked) return;
    setSelectedIndex(Number(e.target.value));
  };

  const handleCheck = useCallback(() => {
    setIsChecked(true);
    if (screenScore != null) {
      submitAnswer(screenId, screenScore, isCorrect);
    }
  }, [isCorrect, screenId, screenScore, submitAnswer]);

  useEffect(() => {
    onCheckStateChange?.({
      checked: isChecked,
      canCheck: true,
      onCheck: handleCheck,
    });
  }, [handleCheck, isChecked, onCheckStateChange, selectedIndex]);

  const fillPercent = (selectedIndex / (options.length - 1)) * 100;

  return (
    <div className="range-quiz quiz-screen">
      <div className={`quiz-card ${isChecked && feedback ? 'blurred' : ''}`}>

        {question && (
          <div
            className={`
              quiz-question
              font-${question?.fontSize ?? 'md'}
              text-${question?.textAlign ?? 'center'}
            `}
            dangerouslySetInnerHTML={{ __html: question.value }}
          />
        )}

        {image && (
          <div className="quiz-image">
            <img src={image} alt="" />
          </div>
        )}

        <div className="range-quiz-wrapper">
          

          <div className="range-quiz-labels">
            {options.map((opt, index) => (
              <div
                key={index}
                className={`
                  range-quiz-label
                  ${index === selectedIndex ? 'active' : ''}
                `}
                dangerouslySetInnerHTML={{ __html: opt.label }}
              >
              </div>
            ))}
          </div>

          <input
              type="range"
              min={0}
              max={options.length - 1}
              step={1}
              value={selectedIndex}
              onChange={handleChange}
              className="range-quiz-slider"
              style={{ '--fill-percent': `${fillPercent}%` }}
          />
        </div>


        {isChecked && feedback && (
          <div
            className={`quiz-feedback ${
              isCorrect
                ? 'quiz-feedback-correct'
                : 'quiz-feedback-incorrect'
            }`}
            dangerouslySetInnerHTML={{
              __html: isCorrect
                ? feedback.correct
                : feedback.incorrect,
            }}
          />
        )}
      </div>
    </div>
  );
}
